import { render, staticRenderFns } from "./HistoryUI.vue?vue&type=template&id=08106278&scoped=true&"
import script from "./HistoryUI.vue?vue&type=script&lang=js&"
export * from "./HistoryUI.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUI.vue?vue&type=style&index=0&id=08106278&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08106278",
  null
  
)

export default component.exports